import gql from 'graphql-tag'

export default (typeId, type) => {
	return {
		mutation: gql`
			mutation updateSingleContractType($type_id: bigint!, $type: String!) {
				update_conf_contract_types_by_pk(
					pk_columns: { id: $type_id }
					_set: { type: $type }
				) {
					id
				}
			}
		`,
		variables: { type_id: typeId, type }
	}
}
